/** Default days of warning before each kind of date (docs/decisions/0012-dates-and-alerts.md). */
export const REMIND_DAYS = {
  /** Tasks, one-off or recurring: only on the day, unless the task says otherwise. */
  task: 0,
  /** Shopping `needed_by`. */
  needed: 3,
  /** Items: use-by and the end of shelf life — time to eat it or rotate it. */
  expires: 30,
  best_before: 14,
  replace: 7,
  /** Documents: renewals take time; a document can override it. */
  document: 90,
} as const;
